import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-aul-013-24",
  standalone: true,
  imports: [],
  templateUrl: "./aul-013-24.component.html",
  styleUrl: "./aul-013-24.component.scss",
})
export class Aul01324Component {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
